import { usePrimaryPage } from '@/PageManager'
import { checkLogin } from '@/atoms/session'
import { useAtomValue } from 'jotai'
import { filteredNewConversationsAtom } from '@/atoms/notifications'
import { hideConversationsAtom } from '@/atoms/preferences'
import { HugeiconsIcon } from '@hugeicons/react'
import { Comment } from '@hugeicons/core-free-icons'
import SidebarItem from './SidebarItem'

export default function ConversationsButton({ collapse }: { collapse: boolean }) {
  const { navigate, current, display } = usePrimaryPage()
  const hasNewConversation = useAtomValue(filteredNewConversationsAtom) > 0
  const hideConversations = useAtomValue(hideConversationsAtom)
  if (hideConversations) return null

  return (
    <SidebarItem
      title="Conversations"
      onClick={() => checkLogin(() => navigate('conversations'))}
      active={display && current === 'conversations'}
      collapse={collapse}
    >
      <div className="relative">
        <HugeiconsIcon icon={Comment} />
        {hasNewConversation && (
          <div className="absolute -top-1 right-0 w-2 h-2 ring-2 ring-background bg-primary rounded-full" />
        )}
      </div>
    </SidebarItem>
  )
}
